import React, { memo } from "react";
import { useMapRenderer } from "./hooks";
// mapbox-gl requires its stylesheet for the canvas/tiles to be positioned and
// sized correctly — without it the map container renders blank. It isn't imported
// globally anywhere, so pull it in alongside the component that renders the map.
import "mapbox-gl/dist/mapbox-gl.css";

const Map = (props: any) => {
	const { buildings = [], addresses = [], ...rest } = props;
	const mapContainer = useMapRenderer(buildings, addresses);

	return (
		<React.Fragment>
			<div ref={mapContainer} style={rest} className="map" />
		</React.Fragment>
	);
};

export default memo(Map);
